import Msd from "@/modules/msd/common/service/Msd";
import Site from "@/modules/msd/unit/service/Site";
import Core from "@/modules/core/service/Core";

const state = {
    manufacturer  : null,
    site          : null,
    customerSites : null,
    enums         : null,
    title         : null,
    assignUnitMode: false,
    month: [
        { id:  1, name: "Januar"},
        { id:  2, name: "Februar"},
        { id:  3, name: "März"},
        { id:  4, name: "April"},
        { id:  5, name: "Mai"},
        { id:  6, name: "Juni"},
        { id:  7, name: "Juli"},
        { id:  8, name: "August"},
        { id:  9, name: "September"},
        { id: 10, name: "Oktober"},
        { id: 11, name: "November"},
        { id: 12, name: "Dezember"}
    ]
}

const mutations = {
    updateMasterDataEnums (state, payload) {
        state.enums = payload;
        state.enums.customer.forEach(c => c.clazz = 'CustomerDto')
        state.enums.limCustomer.forEach(c => c.clazz = 'CustomerDto')
        state.enums.manufacturer.forEach(c => c.clazz = 'CompanyDto')
        state.enums.facilitymanager.forEach(c => c.clazz = 'CompanyDto')
        state.enums.servicecompanies.forEach(c => c.clazz = 'CompanyDto')
        state.enums.zus.forEach(c => c.clazz = 'CompanyDto')
    },

    updateSite (state, payload) {
        state.site = payload;
    },

    updateTitle (state, title) {
        state.title = title;
    },

    updateAssignUnitMode (state, assignUnitMode) {
        state.assignUnitMode = assignUnitMode;
    },

    updateCustoemrSites (state, payload) {
        state.customerSites = payload;
    },
}

const actions = {
    initMasterDataEnums ( { commit }) {
        return Core.method.get(Msd.url.enums).then(data => {
            commit ('updateMasterDataEnums', data);
        })
    },

    setTitle  ( { commit }, title) {
        commit ('updateTitle', title);
    },

    setAssignUnitMode  ( { commit }, assignUnitMode) {
        commit ('updateAssignUnitMode', assignUnitMode);
    },

    findSiteById ( { commit }, siteId) {
        return new Promise((resolve) => {
            Site.site(siteId, data => {
                commit ('updateSite', data);
                resolve(data);
            });
        });

    },
}

const getters = {
    site: state => {
        return state.site;
    },

    customer: state => {
        return state.enums.customer;
    },

    customerContactType: state => {
        return state.enums.customerContactType;
    },

    users: state => {
        return state.enums.users;
    },

    companyStatus: state => {
        return state.enums.companyStatus;
    },

    companyRoles: state => {
        return state.enums.companyRoles;
    },

    limInvoiceHandling: state => {
        return state.enums.limInvoiceHandling;
    },

    contractMntTypes: state => {
        return state.enums.contractMntTypes;
    },

    frequency: state => {
        return state.enums.frequency;
    },

    msd: state => {
        return state.enums;
    },

    month: state => {
        return state.month;
    },

    title: state => {
        return state.title;
    },

    assignUnitMode: state => {
        return state.assignUnitMode;
    },
}

const siteModule = {
    state,
    mutations,
    actions,
    getters
}

export default siteModule